/* eslint-disable @typescript-eslint/camelcase */
import { FormUser } from 'modules/clients/interfaces';

export const initialValues: FormUser = {
  first_name: '',
  last_name: '',
  email: '',
  username: '',
};
